import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import Fab from '@material-ui/core/Fab';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Info from '@material-ui/icons/Info';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import AccessTime from '@material-ui/icons/AccessTime';

import { getRangoHorarios } from '../../helpers/getRangoHorario';

export default function AlertDialog({ linea, botonIcons = true }) {
  const [open, setOpen] = useState(false);

  const { token } = useSelector((state) => state.auth);

  const [mensajeRango, setMensajeRango] = useState();

  const armarMensaje = (response) => {
    let idL = 0;
    let idR = 0;

    const text = response.map((mr) => (
      <>
        <tbody>
          {idL != mr.linea.id ? (
            <>
              <tr>
                <td style={{ height: '18px' }}></td>
              </tr>
              <tr>
                <td style={{ textAlign: 'left' }}>
                  Para la línea <b>{mr.linea.nombre}</b>, podes reservar de Lunes a Viernes y Sábads en estos
                  horarios:
                </td>
              </tr>
              <tr>
                <td style={{ borderBottom: '2px solid #ddd' }}></td>
              </tr>
            </>
          ) : (
            ''
          )}
          {idR != mr.ramal.id ? (
            <tr>
              <td style={{ textAlign: 'left' }}>
                Ramal <b> {mr.ramal.nombre} </b> :
              </td>
            </tr>
          ) : (
            ''
          )}
          <tr>
            <td>
              sentido <b> {mr.sentido.nombre} </b> de {mr.desde.substr(0, 5)} a{' '}
              {mr.hasta.substr(0, 5)}
            </td>
          </tr>
          <tr>
            <td style={{ display: 'none' }}>{(idL = mr.linea.id)} </td>
            <td style={{ display: 'none' }}>{(idR = mr.ramal.id)} </td>
          </tr>
        </tbody>
      </>
    ));

    return <table style={{ maxWidth: '500px', margin: 'auto' }}>{text}</table>;
  };

  const handleClickOpen = () => {
    const getRangos = async () => {
      const response = await getRangoHorarios(token, linea);
      setMensajeRango(armarMensaje(response.data));
    };
    getRangos();

    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      {botonIcons ? (
        <IconButton
          aria-label='delete'
          variant='outlined'
          // color='#4CAF50'
          style={linea ? { color: '#4CAF50' } : {}}
          onClick={handleClickOpen}
          disabled={!linea ? true : false}
        >
          <Info />
        </IconButton>
      ) : (
        <Fab
          // color='secondary'
          title='Horarios de Servicios Disponibles'
          style={{
            position: 'fixed',
            right: '20px',
            bottom: '170px',
            color: '#ffffff',
            background: 'rgb(77, 175, 78)',
          }}
          onClick={handleClickOpen}
        >
          <AccessTime />
        </Fab>
      )}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle
          style={{ background: '#01579b', color: '#ffffff' }}
          id='alert-dialog-title'
        >
          {'Horarios de Reserva.'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id='alert-dialog-description'
            style={{ textAlign: 'center' }}
          >
            {mensajeRango}
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ borderBottom: '10px solid #01579b' }}>
          <Button onClick={handleClose} color='primary'>
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
